import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoListEdit from "../../components/PageInfoListEdit";
import SimpleInfoEdit from "../../components/SimpleInfoEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";

export default function Alle() {
    const uploadFolderId = '13gHPsZzfoHdXjNWvnbXItg10WUoEkyIC';
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/FaellesskabAlle">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoListEdit sectionKey="pageContent">
                    <SimpleInfoEdit sectionKey="bornekirke"/>
                    <SimpleInfoEdit sectionKey="juniortraef"/>
                    <SimpleInfoEdit sectionKey="teensamling"/>
                    <SimpleInfoEdit sectionKey="bedemode"/>
                    <SimpleInfoEdit sectionKey="kGrupper"/>
                    <SimpleInfoEdit sectionKey="holdMasken"/>
                    <SimpleInfoEdit sectionKey="hjerterum"/>
                    <SimpleInfoEdit sectionKey="hTeenklub"/>
                    <SimpleInfoEdit sectionKey="club4"/>
                    <SimpleInfoEdit sectionKey="ullerødderne"/>
                    <SimpleInfoEdit sectionKey="spiren"/>
                    <SimpleInfoEdit sectionKey="vuf"/>
                    <SimpleInfoEdit sectionKey="fredagssport"/>
                    <SimpleInfoEdit sectionKey="gudstjeneste"/>
                    <SimpleInfoEdit sectionKey="kvindekvinde"/>
                    <SimpleInfoEdit sectionKey="hrligt"/>
                    <SimpleInfoEdit sectionKey="refleks"/>
                    <SimpleInfoEdit sectionKey="nødebo"/>
                    <SimpleInfoEdit sectionKey="u1"/>
                    <SimpleInfoEdit sectionKey="u2"/>
                    <SimpleInfoEdit sectionKey="u3"/>
                    <SimpleInfoEdit sectionKey="u4"/>
                    <SimpleInfoEdit sectionKey="u5"/>
                </PageInfoListEdit>
            </EditPage>
        </UploadFolderIdProvider>
    );
}